import { render, staticRenderFns } from "./kecermatan.vue?vue&type=template&id=37e87fd5&scoped=true&"
import script from "./kecermatan.vue?vue&type=script&lang=js&"
export * from "./kecermatan.vue?vue&type=script&lang=js&"
import style0 from "./kecermatan.vue?vue&type=style&index=0&id=37e87fd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e87fd5",
  null
  
)

export default component.exports